/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Facility } from './Facility';
import {
    FacilityFromJSON,
    FacilityFromJSONTyped,
    FacilityToJSON,
    FacilityToJSONTyped,
} from './Facility';

/**
 * 
 * @export
 * @interface UserFacilityAccess
 */
export interface UserFacilityAccess {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    granted_by_user_id?: string;
    /**
     * 
     */
    facility: Facility;
    /**
     * 
     */
    granted_by_user_name?: string;
}

/**
 * Check if a given object implements the UserFacilityAccess interface.
 */
export function instanceOfUserFacilityAccess(value: object): value is UserFacilityAccess {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('facility' in value) || value['facility'] === undefined) return false;
    return true;
}

export function UserFacilityAccessFromJSON(json: any): UserFacilityAccess {
    return UserFacilityAccessFromJSONTyped(json, false);
}

export function UserFacilityAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFacilityAccess {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'user_id': json['user_id'],
        'granted_by_user_id': json['granted_by_user_id'] == null ? undefined : json['granted_by_user_id'],
        'facility': FacilityFromJSON(json['facility']),
        'granted_by_user_name': json['granted_by_user_name'] == null ? undefined : json['granted_by_user_name'],
    };
}

export function UserFacilityAccessToJSON(json: any): UserFacilityAccess {
    return UserFacilityAccessToJSONTyped(json, false);
}

export function UserFacilityAccessToJSONTyped(value?: UserFacilityAccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'user_id': value['user_id'],
        'granted_by_user_id': value['granted_by_user_id'],
        'facility': FacilityToJSON(value['facility']),
        'granted_by_user_name': value['granted_by_user_name'],
    };
}

